module.exports = __webpack_public_path__ + "img/logo.4eae9b0b.png";